export const SUBGRAPH_METADATA_QUERY = `{
	_meta {
	  block {
		number
	  }
	}
  }`;
